module.exports = __webpack_public_path__ + "img/error.c88ab08a.png";